import PropTypes from 'prop-types';
import theme from '../../../../../ui-kit/themes/theme';
import { SummaryContent } from '../../../Content';
import * as COPY from '../../utilities/copy';
import { TotalSavingsContainer } from '../styles';

const propTypes = {
  handleSavings: PropTypes.func
};

export const TotalSavings = ({ handleSavings, isCartVariation, shouldDisplayTotalSavings }) => {
  const value = handleSavings();
  if (!shouldDisplayTotalSavings) return null;
  return (
    <>
      {!isCartVariation ? <SummaryContent.Divider /> : null}
      <TotalSavingsContainer isCartVariation={isCartVariation}>
        <SummaryContent.Item
          color={isCartVariation ? theme.colors.successGreen : theme.colors.deepForestGreen[100]}
          fontSize={['14px', null, null, '14px']}
          fontWeight={theme.fontWeights.bold}
          lineHeight={'22px'}>
          <SummaryContent.Description data-testid="suite-total">{COPY.TOTAL_SAVINGS}</SummaryContent.Description>
          <SummaryContent.SubtotalAmount
            color={isCartVariation ? theme.colors.successGreen : theme.colors.deepForestGreen[100]}
            fontSize={['14px', null, null, '14px']}
            fontWeight={theme.fontWeights.bold}
            lineHeight={'18px'}>
            {`${!isCartVariation && value > 0 ? '-' : ''}$${value.toFixed(2)}`}
          </SummaryContent.SubtotalAmount>
        </SummaryContent.Item>
      </TotalSavingsContainer>
    </>
  );
};

TotalSavings.propTypes = propTypes;
